import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  NotificationMessage,
  NotificationsQueue,
} from '@/components/Notifications';
import { Endpoint, QueryKey } from '@/constants';
import { getData } from '@/utils/getData';

const cardLength = 16;

export const useGetLoyaltyCardBalance = (loyaltyCardNumber: string) => {
  const isValidLoyaltyCard = loyaltyCardNumber.length === cardLength;
  const queryObject = { loyaltyCardNumber };

  const { data, isFetched } = useQuery({
    enabled: isValidLoyaltyCard,
    queryFn: getData(Endpoint.GetLoyaltyCardBalance, queryObject),
    queryKey: [QueryKey.LoyaltyCardBalance, queryObject],
  });

  const errorMessage = data?.messages[0];

  useEffect(() => {
    if (isFetched && !data?.isSuccess) {
      NotificationsQueue.add(
        {
          notification: (
            <NotificationMessage $isError={true}>
              {errorMessage}
            </NotificationMessage>
          ),
        },
        { timeout: 5000 },
      );
    }
  }, [data?.isSuccess, errorMessage, isFetched]);

  return data?.data;
};
